import { useMemo, useState } from "react";
import { Row, Col, Button, Container, Form, InputGroup } from "react-bootstrap";
import { Grid } from "@mui/material";
import { Helmet } from "react-helmet";
import SewCard from "../components/SewCard";
import SewMap from "../components/SewMap";
import Loading from "../components/Loading";
import { useSew } from "../contexts/SewContext";
import { LuInfo } from "react-icons/lu";
import { IoIosSearch } from "react-icons/io";
import "../css/Home.css";

const SewList = () => {
    const { sewAssets, isLoading } = useSew();
    const [searchValue, setSearchValue] = useState("");

    const assets = useMemo(() => Object.values(sewAssets), [sewAssets]);

    const visibleAssets = useMemo(() => {
        const query = searchValue.trim().toLowerCase();
        if (!query) {return assets;}
        return assets.filter((asset) => {
            return [asset?.Name, asset?.Classification, asset?.Type, String(asset?.Id)]
                .some((field) => field && field.toLowerCase().includes(query));
        });
    }, [assets, searchValue]);

    return (
        <Container className="home-container">
            <Helmet>
                <title>SEW Systems</title>
            </Helmet>

            {/* Title row */}
            <Row className="mb-3">
                <Col>
                    <h4 className="home-title">
                        SEW Systems <span className="sat-count">({assets.length})</span>
                    </h4>
                </Col>
            </Row>

            {/* Search bar */}
            <Row className="mb-2">
                <Col>
                    <InputGroup className="search-input-group">
                        <Form.Control
                            type="text"
                            name="search"
                            value={searchValue}
                            placeholder="Search by name, classification, or type..."
                            onChange={(event) => setSearchValue(event.target.value)}
                        />
                        <Button
                            variant="warning"
                            title="Search"
                            className="search-button"
                        >
                            <IoIosSearch style={{ fontSize: "1.1rem", color: "black" }} />
                        </Button>
                    </InputGroup>

                    {!isLoading && searchValue && visibleAssets.length === 0 && (
                        <p className="no-results-text">No matching SEW systems found</p>
                    )}
                </Col>
            </Row>

            {/* Info notice */}
            <Row className="mb-3">
                <Col>
                    <p className="info-notice">
                        <LuInfo className="me-1" />
                        This is publicly available information and was not provided through Intel channels.
                    </p>
                </Col>
            </Row>

            {/* Overview map of all (filtered) SEW systems */}
            {visibleAssets.length > 0 && (
                <Row className="mb-4">
                    <Col>
                        <SewMap assets={visibleAssets} height={620} />
                    </Col>
                </Row>
            )}

            {isLoading && assets.length === 0 && <Loading />}

            <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                {visibleAssets.map((asset) => (
                    <Grid item key={asset.Id} xs={12} sm={12} md={6} lg={4}>
                        <SewCard asset={asset} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default SewList;
